export module OCRUtil {
    export function toBase64(file: File) {
        const promise = new Promise<string>((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => reader.result ? resolve(reader.result.toString()) : null
            reader.onerror = (error) => reject(error)
        })
        return promise
    }

    export function clearMeta(text: string) {
        text = text.replace(/^data:image\/[a-z]+;base64,/, '')
        return text.replace(/^data:application\/pdf;base64,/, '')
    }
}
